import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import classnames from "classnames";
import FormErrorMessage from "components/components/FormErrorMessage/FormErrorMessage";
import React, { forwardRef, InputHTMLAttributes, useState } from "react";
import colours from "styles/colours";

import { StyledInput } from "./style";

interface Props {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  name: string;
  id: string;
  label: string;
  maxLength?: number;
  required?: boolean;
  type?: InputHTMLAttributes<HTMLInputElement>["type"];
  placeholder?: string;
  validate: (title: string) => string | null;
}

const QueueTitleInput: React.FC<Props & React.RefAttributes<HTMLInputElement>> =
  forwardRef<HTMLInputElement, Props>(function TextInput(
    {
      onChange,
      value,
      name,
      id,
      label,
      maxLength,
      required,
      type = "text",
      placeholder = "",
      validate,
    }: Props,
    ref
  ) {
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
      const newValue = event.target.value;
      const error = validate(newValue);
      setErrorMessage(error);
      onChange(event);
    };

    return (
      <div className="queue-title-input">
        <label htmlFor={id}>
          <span>{label}</span>
          <div
            className={classnames("control", {
              "has-icons-left": !!errorMessage,
            })}
          >
            <StyledInput
              className={classnames("input", { invalid: !!errorMessage })}
              id={id}
              value={value}
              name={name}
              maxLength={maxLength}
              onChange={handleChange}
              required={required}
              type={type}
              ref={ref}
              placeholder={placeholder}
            />
            {errorMessage && (
              <FormErrorMessage
                iconName={faInfoCircle}
                iconColour={colours.elexonRed}
                messageText={errorMessage}
              />
            )}
          </div>
        </label>
      </div>
    );
  });

export default QueueTitleInput;
